import React, { PropsWithChildren } from 'react'
import { Detail } from '~/app/components/order-list/common/OrderDetailsCommonStyled'

/**
 * ItemView component
 * author: soojin.oh
 */

// type definitions
type ItemViewProps = { title: string; description?: string | null } & Pick<
  React.HTMLProps<HTMLDivElement>,
  'style'
>

// ItemView component
const ItemView = function ({
  title,
  description = '',
  style,
  children,
}: PropsWithChildren<ItemViewProps>) {
  return (
    <Detail style={style}>
      {title && <div className={'title'}>{title}</div>}
      {description && <div className={'description'}>{description}</div>}
      {children}
    </Detail>
  )
}

export default ItemView
